module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation15.a865f5d0.png";